import React from 'react';
import NotFound from '../pages/NotFound';
import { useUserContext } from '../contexts/UserContext';

type Props = {
  children?: React.ReactNode
  feature?: string
};

const PrivateRoute: React.FC<Props> = ({ children, feature }) => {
  const { userCan } = useUserContext();

  if (!children) return null;
  if (!feature) return <>{children}</>;

  return <>{(userCan(feature)) ? children : <NotFound />}</>;
};

export default PrivateRoute;
